import { ComponentChildren } from 'preact';
import { useMemo } from 'preact/hooks';

export type UseClearIconProps = {
  clearIcon?: ComponentChildren;
  display?: 'always' | 'conditionally' | 'never';
  hasValue?: boolean;
  isEnabled?: boolean;
  isFocused?: boolean;
  isHover?: boolean;
};

/**
 * A custom hook that handles showing/hiding clear icon
 */
export function useClearIcon({
  clearIcon,
  display,
  hasValue,
  isEnabled = true,
  isFocused = false,
  isHover = false
}: UseClearIconProps) {
  const shouldRenderClearIcon = useMemo(
    () =>
      isEnabled &&
      (display === 'always' || (display === 'conditionally' && hasValue && (isFocused || isHover))),
    [display, hasValue, isEnabled, isFocused, isHover]
  );

  return shouldRenderClearIcon ? clearIcon : null;
}
